module.exports = __webpack_public_path__ + "img/pic_france_01.55b7ffc7.jpg";